import './css/caseStudy.css';
import pic1 from '../photos/case studies/book corner.png';
import pic2 from '../photos/Case-study2.png';
import pic3 from '../photos/Case-study3.png';
import '../components/css/styleToAll.css';
import Navbar from './Navbar';
import { useState } from 'react';


const c = {backgroundColor:"#f7f9fb"};
const b = {backgroundColor: "rgb(227 253 243)"};
const d = {background: "#E7DAED"};
const uiLink = 

 <a href="https://drive.google.com/file/d/1YlJADeMriDpclBA4dBlit0737PQpqN33/view?usp=sharing" style={{color:"#000",float:"none"}} target="_blank" rel="noopener noreferrer">  
        Google drive link
        </a>  
export default function CaseStudy(){
  const [myMode,setMymode] =useState("light");
    const casesShow = [
        {id : 1 , pic : pic1  , h3Text : "Web Application... Book store ", pText : "your one-stop destination for all things literary. Whether you're a casual reader or a dedicated bibliophile, our store offers a vast collection of books across all genres and formats. Find the best books from your favorite writers, explore hundreds of books with all possible categories, take advantage of the 50% discount and much more.",link:"https://book-corner-1.netlify.app/"},
        {id : 2 , pic : pic2 , h3Text : "Mobile Application... ", pText : "Born out of a vision, a single-minded objective that puts service before anything else, Swift Clearance and Forwarding Corp. surging forth to deliver the best services in the shipping and logistics scenario. Its meteoric rise stems out of a solid foundation. The management boasts of over 20 years of rich and varied experience in the shipping and freight forwarding industry." ,link:"SOON..."  },
        {id : 3 , pic : pic3 , h3Text : "UI/UX Design... techno media", pText : "Here’s a concise description you can use for a link showcasing your company UI/UX design projects:Explore our portfolio of innovative UI/UX design projects that highlight our commitment to creating user-centered experiences. Discover how we blend creativity and functionality to deliver exceptional digital solutions tailored to meet client needs." ,link:uiLink  }
    ];
    const cases = casesShow.map((caseShow ) => {
        return (
            <div className='flex-caseStudy' key ={caseShow.id}>
                        <Navbar className="nav-cont" setMymode={setMymode}/>
                <div className='pic'>
                   <img  src={caseShow.pic} alt= "case study"/>
                </div>
                <div  className ="case-text" style = {caseShow.stylee}>
                    <h3> {caseShow.h3Text}</h3>
                    <p>{caseShow.pText}</p>
<div className='more'>
                    <a href='#'> Read More 
                    </a>
                    <a href={caseShow.link} target='_blank' className='link'><span style={{color:"#000",fontWeight:"500",fontSize:"20px",display:"inline-block",marginRight:"5px"}}>Demo:</span>{caseShow.link}</a>
</div>
                </div>
            
            </div>

        );

    });


    return(
    <>  
    <Navbar style={{width:"100%"}} setMymode={setMymode}/>
            <section  className="case-study">
            <div className= "container-caseStudy"> 
            <hr/>
            <h2>
                <span>  Our recent</span>
                Case studies
            </h2>
            <article>
                     {cases}

            </article>

         </div>
        </section>
    </>
    );
}



/*

*/ 